import * as React from "react";
import { Button, Form, Input, message, Select, Checkbox, Row, Col } from "antd";
import { makeStyles } from "@material-ui/core/styles";
import config from "../../../config";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-bootstrap/Modal";
import { PercentageOutlined, PlusOutlined } from "@ant-design/icons";

const useStyles = makeStyles((theme) => ({
  formInput: {
    borderRadius: 8,
  },
  formItem: {
    "& .ant-col ant-col-24 ant-form-item-label": {
      padding: 0,
    },
  },
  selectInput: {
    "&.ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector":
      {
        borderRadius: "0 8px 8px 0",
      },
  },
  unitFormItem: {
    borderRadius: "8px 0 0 8px",
  },
  taxTypeInput: {
    "&.ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector":
      {
        borderRadius: 8,
      },
  },
}));

const Taxmaster = ({ initialValues, show, setShow, mode, fetchTaxsList }) => {
  const classes = useStyles();
  const [form] = Form.useForm();
  const shopDetails = useSelector((state) => state.shopDetails);
  const dispatch = useDispatch();
  const taxTypes = useSelector((state) => state.shopDetails.customTaxType);
  const [loading, setLoading] = React.useState(false);

  const handleClose = () => {
    form.resetFields();
    setShow(false);
  };

  const addTax = async (taxObject) => {
    try {
      var res = await fetch(`${config.newApiGateway}/taxMaster/taxMaster`, {
        method: "POST",
        body: JSON.stringify({
          taxObject: taxObject,
          action: "add",
          shopId: shopDetails.shopId,
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      });
      res = await res.json();
      if (res.code === "ERROR") {
        return alert(res.message);
      }
      if (res.code === "SUCCESS") {
        message.success("Tax Added Successfully");
        fetchTaxsList(shopDetails.shopId);
        form.resetFields();
        setShow(false);
        dispatch({
          type: "SET_TAX_LIST",
          payload: res.data.Attributes.taxMaster,
        });
      }
    } catch (err) {
      console.log(err);
      message.error("Error while Adding Tax. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => form.resetFields(), [initialValues, form]);

  const editData = async (taxObject) => {
    try {
      var res = await fetch(`${config.newApiGateway}/taxMaster/taxMaster`, {
        method: "POST",
        body: JSON.stringify({
          taxObject: taxObject,
          action: "edit",
          shopId: shopDetails.shopId,
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      });
      res = await res.json();
      if (res.code === "ERROR") {
        return message.error(res.message);
      }
      if (res.code === "SUCCESS") {
        fetchTaxsList(shopDetails.shopId);
        message.success("Tax Edited Successfully");
        form.resetFields();
        setShow(false);
        dispatch({
          type: "SET_TAX_LIST",
          payload: res.data.Attributes.taxMaster,
        });
      }
    } catch (err) {
      setLoading(false);
      console.log(err);
      message.error("Error while Editing Tax. Please try again.");
    }
  };

  const onFinish = async (values) => {
    setLoading(true);
    const taxObject = {
      ...(mode === "edit" && { taxId: initialValues.taxId }),
      ...values,
      ...(["Outlet", "Employee"].includes(shopDetails.userType) && {
        shopId: shopDetails.shopId,
        ownerShopId: shopDetails.ownerShopId,
      }),
    };
    mode === "add" ? addTax(taxObject) : editData(taxObject);
  };

  return (
    <Modal backdrop="static" show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{mode === "add" ? "Add Tax" : "Edit Tax"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form
          form={form}
          labelCol={{
            span: 24,
          }}
          wrapperCol={{
            span: 24,
          }}
          onFinish={onFinish}
          initialValues={{
            taxName: initialValues.taxName,
            taxType: initialValues.taxType,
            gst: initialValues.gst,
            igst: initialValues.igst,
            cess: initialValues.cess,
            additionalcess: initialValues.additionalcess,
            ...initialValues,
          }}
        >
          <Form.Item
            name={"taxType"}
            className={classes.formItem}
            label="Tax Type"
            style={{
              marginBottom: 2,
            }}
            rules={[
              {
                required: true,
                message: "Please select atleast one TaxType",
              },
            ]}
          >
            <Select mode="multiple" placeholder="Select a Tax Type">
              <Select.Option key={"gst"} value={"gst"}>
                GST
              </Select.Option>
              <Select.Option key={"cess"} value={"cess"}>
                Cess
              </Select.Option>
              <Select.Option key={"additionalcess"} value={"additionalcess"}>
                Additional Cess
              </Select.Option>
              <Select.Option key={"igst"} value={"igst"}>
                IGST
              </Select.Option>
              {console.log("customTaxType111", shopDetails.customTaxType)}
              {taxTypes.map((tax) => (
                <Select.Option key={tax.taxId} value={tax.taxId}>
                  {shopDetails.customTaxType?.find(
                    (customTax) => customTax.taxId === tax.taxId
                  )?.label || tax.taxName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            noStyle
            shouldUpdate={(prevValues, currentValues) =>
              prevValues.taxType !== currentValues.taxType
            }
          >
            {({ getFieldValue }) => {
              return getFieldValue("taxType")?.includes("gst") ? (
                <Form.Item
                  name="gst"
                  label="GST(%)"
                  rules={[
                    { required: true, message: "Gst should not be Empty" },
                    {
                      pattern: /^(\d+(\.\d+)?)$/,
                      message: "Please enter a number only",
                    },
                  ]}
                >
                  <Input suffix={<PercentageOutlined />} />
                </Form.Item>
              ) : null;
            }}
          </Form.Item>
          {console.log("initialValues", initialValues)}
          {taxTypes.map((tax) => (
            <Form.Item
              key={tax.taxId}
              noStyle
              shouldUpdate={(prevValues, currentValues) =>
                prevValues.taxType !== currentValues.taxType
              }
            >
              {({ getFieldValue }) => {
                return getFieldValue("taxType")?.includes(tax.taxId) ? (
                  <Form.Item
                    name={tax.taxName}
                    label={`${tax.taxName}(%)`}
                    rules={[
                      {
                        required: true,
                        message: `${tax.taxName} should not be Empty`,
                      },
                      {
                        pattern: /^(\d+(\.\d+)?)$/,
                        message: "Please enter a number only",
                      },
                    ]}
                  >
                    <Input suffix={<PercentageOutlined />} />
                  </Form.Item>
                ) : null;
              }}
            </Form.Item>
          ))}
          <Form.Item
            noStyle
            shouldUpdate={(prevValues, currentValues) =>
              prevValues.taxType !== currentValues.taxType
            }
          >
            {({ getFieldValue }) => {
              return getFieldValue("taxType")?.includes("igst") ? (
                <Form.Item
                  name="igst"
                  label="IGST(%)"
                  rules={[
                    { required: true, message: "Igst should not be Empty" },
                    {
                      pattern: /^(\d+(\.\d+)?)$/,
                      message: "Please enter a number only",
                    },
                  ]}
                >
                  <Input suffix={<PercentageOutlined />} />
                </Form.Item>
              ) : null;
            }}
          </Form.Item>
          <Form.Item
            noStyle
            shouldUpdate={(prevValues, currentValues) =>
              prevValues.taxType !== currentValues.taxType
            }
          >
            {({ getFieldValue }) => {
              return getFieldValue("taxType")?.includes("cess") ? (
                <Form.Item
                  name="cess"
                  label="CESS(%)"
                  rules={[
                    { required: true, message: "Cess should not be Empty" },
                    {
                      pattern: /^(\d+(\.\d+)?)$/,
                      message: "Please enter a number only",
                    },
                  ]}
                >
                  <Input suffix={<PercentageOutlined />} />
                </Form.Item>
              ) : null;
            }}
          </Form.Item>
          <Form.Item
            noStyle
            shouldUpdate={(prevValues, currentValues) =>
              prevValues.taxType !== currentValues.taxType
            }
          >
            {({ getFieldValue }) => {
              return getFieldValue("taxType")?.includes("additionalcess") ? (
                <Form.Item
                  name="additionalcess"
                  label="Additional Cess(%)"
                  rules={[
                    {
                      required: true,
                      message: "Additional Cess should not be Empty",
                    },
                    {
                      pattern: /^(\d+(\.\d+)?)$/,
                      message: "Please enter a number only",
                    },
                  ]}
                >
                  <Input suffix={<PercentageOutlined />} />
                </Form.Item>
              ) : null;
            }}
          </Form.Item>
          <Form.Item
            name={"taxName"}
            className={classes.formItem}
            label="Tax Name"
            rules={[
              {
                required: true,
                message: "Please enter a Tax Name",
              },
            ]}
          >
            <Input placeholder="Enter a Tax Name" />
          </Form.Item>
          <Button
            style={{
              marginLeft: "0.5rem",
              paddingLeft: "1rem",
              paddingRight: "1rem",
              borderRadius: 4,
            }}
            onClick={() => setShow(false)}
          >
            Close
          </Button>
          <Button
            htmlType="submit"
            type="primary"
            style={{
              marginLeft: "0.5rem",
              paddingLeft: "1rem",
              paddingRight: "1rem",
              borderRadius: 4,
            }}
            loading={loading}
            disabled={loading}
          >
            {mode === "add" ? "Add" : "Save"}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default Taxmaster;
